<div class="different-icon-wrapper" [style]="differentIconStylePosition">
  <img
    class="different-icon"
    [ngSrc]="SPIDER_CHART_CONFIG.differentPoints.imgSrc"
    [width]="SPIDER_CHART_CONFIG.differentPoints.width"
    [height]="SPIDER_CHART_CONFIG.differentPoints.height"
    alt="different-icon"
  />
</div>
